import React from 'react'

import Box from '@mui/material/Box'

// components
import Typography from '@mui/material/Typography'

const BackupCareHeader = props => (
  <Box my={2}>
    <Typography my={2} align='center' variant='h4'>
      Log in or create an account to activate your special Bright Horizons
      rates.*
    </Typography>
  </Box>
)

export default BackupCareHeader
